var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_ChooseFee"),
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: _vm.cancel
          }
        },
        [
          _c("cargo-ag-grid", {
            style: { width: "100%", height: "300px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            }
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "1", size: "mini" },
                  on: { click: _vm.successEvent }
                },
                [_vm._v(_vm._s(_vm.$t("Billing.billingView_Determine")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini", no: "2" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("Billing.billingView_Close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }